export default class CandenoLogin {
  constructor(element) {
    this.el = element;
    this.buttontext = this.el.dataset.buttontext;
    this.getCandenoLogin = this.getCandenoLogin.bind(this);
    this.loginToCandeno = this.loginToCandeno.bind(this);
    this.buttontype = this.el.dataset.buttontype;
    this.bgcolor = this.el.dataset.bgcolor;
    this.svgcolor = this.el.dataset.svgcolor;
    this.init();
  }

  init() {
    this.getCandenoLogin();
  }

  getCandenoLogin() {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch("/api/memberdata/GetCandenoToken", requestOptions)
      .then((response) => response.text())
      .then((result) => this.loginToCandeno(result))
      .catch((error) => console.error(error));
  }

  loginToCandeno(result) {
    let resultObject = JSON.parse(result);
    let buttonstyle = this.buttontype === "cta" ? "btn-primary" : this.bgcolor ? this.bgcolor : "bg-primary";
    let svgstyle = this.svgcolor ? this.svgcolor : "fill-white";
    let topMargin = this.buttontype === "arrowLink" ? "mt-8 mb-16" : "mt-0";
    const formButton = `
      <form id="myForm" action="${resultObject.loginUrl}" method="POST" target="_blank">
        <input type="hidden" name="client_id" value="${resultObject.clientId}">
        <input type="hidden" name="jwt" value="${resultObject.token}">
        <button class="${buttonstyle} group h-full w-full flex ${topMargin}" data-component="candeno-login"><span class="min-w-[24px] md:min-w-0"></span><span class="justify-center">${this.buttontext}</span><svg class="h-6 w-6 min-h-[24px] min-w-[24px] ${svgstyle} dot-arrow-animation aspect-square"><use xlink:href="/spritemap.svg#sprite-dotarrow"></use></svg></button>
      </form>    
    `;

    this.el.innerHTML = formButton;
  }
}
